import { render, staticRenderFns } from "./SpecialComment.vue?vue&type=template&id=12742db0&scoped=true&lang=html"
import script from "./SpecialComment.vue?vue&type=script&lang=js"
export * from "./SpecialComment.vue?vue&type=script&lang=js"
import style0 from "./SpecialComment.vue?vue&type=style&index=0&id=12742db0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12742db0",
  null
  
)

export default component.exports